import { fetch } from '~/api/request';
const DataSource: XOSS.IDataSource = {
  prepare(data) {
    return fetch('/youyan/upload_media_v3/prepare_upload/', {
      method: 'POST',
      body: data,
      autoErrorHandle: false,
    }).then(({ code, data, msg }) => {
      console.log('🚀 / prepare / data:', data);
      if (code === 0 && !!data) {
        return data;
      }

      return Promise.reject({
        msg: data.failed_info.detail || msg,
        upload_secret_id: data?.upload_secret_id,
        info: data.failed_info,
      });
    });
  },
  prepareSimpleUpload(data) {
    return fetch('/youyan/upload_media_v3/prepare_simple_upload/', {
      method: 'POST',
      body: data,
    }).then(({ code, data, msg }) => {
      console.log('🚀 / prepare / data:', data);
      if (code === 0 && !!data) {
        return data;
      }
      return Promise.reject(data.failed_info.detail || msg);
    });
  },
  queryStatus(params) {
    return fetch('/youyan/upload_media_v3/status/', { params }).then(({ code, data, msg }) => {
      if (code === 0) {
        return data;
      }
      return Promise.reject(msg);
    });
  },
  batchQuery(params) {
    return fetch('/youyan/upload_media_v3/batch_status/', { params }).then(({ code, data }) => {
      return code === 0 ? data : [];
    });
  },
  cancel(data) {
    return fetch('/youyan/upload_media_v3/cancel/', {
      method: 'POST',
      body: data,
    }).then(({ code, data, msg }) => {
      if (code === 0) {
        return data;
      }
      return Promise.reject(msg);
    });
  },
  remove(params) {
    return fetch('/youyan/upload_media_v3/', { method: 'DELETE', params }).then(
      ({ code, data, msg }) => {
        if (code === 0) {
          return Promise.resolve();
        }
        return Promise.reject(msg);
      },
    );
  },
};

export default DataSource;
